<div class="wrap">
  <header>
    <button
      mat-icon-button
      aria-label="Close"
      class="close-button"
      (click)="close()"
    >
      <span class="icon-close"></span>
    </button>
  </header>

  <div class="content">
    <h1 class="transfer-title">{{ 'access_control.dialog.transfer_title' | translate }}</h1>
    <p class="transfert-sub-title">{{ 'access_control.dialog.transfer_sub_title' | translate }}</p>

    <!-- User Display Section -->
    <div class="user-display-section" *ngIf="selectedUsers.length > 0">
      <div class="user-avatars">
        <img
          *ngFor="let user of selectedUsers.slice(0, 3); trackBy: trackByUserId"
          [src]="getUserAvatarUrl(user)"
          [alt]="getUserDisplayName(user)"
          class="user-avatar">
        <div *ngIf="selectedUsers.length > 3" class="user-count">
          <span class="count-text">+{{ selectedUsers.length - 3 }}</span>
        </div>
      </div>
    </div>

    <!-- Role Selection Section -->
    <div class="role-selection-section">
      <span class="headerName">{{ 'access_control.dialog.select_role' | translate }}</span>
      <app-role-selector
                [role]="assignableRoles"
                (selected)="onRoleSelectionChanged($event)"
                >
        </app-role-selector>
    </div>

    <!-- Loading indicator -->
    <div class="loading-section" *ngIf="loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="30">
      </mat-progress-spinner>
    </div>
  </div>

  <!-- Dialog Actions -->
  <footer>
    <button
      class="bciti-button bciti-button--black-inversed"
      (click)="cancel()">
      {{ 'access_control.dialog.cancel' | translate }}
    </button>
    <button
      class="bciti-button bciti-button--black"
      [disabled]="loading || !roleIsSelected()"
      (click)="transferUsers()">
      <span *ngIf="!loading">
        {{ 'access_control.dialog.transfer' | translate }}
      </span>
      <span *ngIf="loading">
        {{ 'access_control.list.assigning' | translate }}
      </span>
    </button>
  </footer>
</div>